import React from 'react';
import { Button, type ButtonProps } from 'reactstrap';

interface ButtonWithLoaderProps extends ButtonProps {
  isLoading?: boolean;
}

const ButtonWithLoader = ({
  children, isLoading = false, disabled = false, ...otherProps
}: ButtonWithLoaderProps) => (
  <Button
    className="d-flex gap-2 align-items-center justify-content-center"
    {...otherProps}
    disabled={isLoading || disabled}
  >
    {isLoading ? <span className="spinner-border spinner-border-sm d-inline-block" /> : ''}
    {children}
  </Button>
);

export default ButtonWithLoader;
